import {
  OrderTable,
  OrderTableFilters,
  useDefaultHtzOrderListRequest,
} from "@/services/backend/htz/orders/components/order-table";
import { NavLink, useNavigate, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import t from "@/lang/lang";
import { CreateOrderButton } from "@/services/backend/htz/orders/components/create-order-button";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { HtzBreadcrumbs } from "@/routes/processes/[processId]/htz/_components/htz-breadcrumbs";

export function OrdersIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  const [request, setRequest] = useState(
    useDefaultHtzOrderListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  if (!data) return null;

  const breadcrumbs = (
    <HtzBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Auftragseingänge")}</BreadcrumbPage>
      </BreadcrumbItem>
    </HtzBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle>{t("Auftragseingänge")}</MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <OrderTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <CreateOrderButton
                processId={processId!}
                onCreated={(id) => navigate(id)}
              />
            </div>
            <OrderTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={renderRowLink}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
